import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Classes = (store) => ({
  path: ROUTE.CLASSES,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'classes',
    loadReducer: () => import('./ClassesState'),
    loadComponent: () => import('./ClassesContainer'),
  })
})

export default Classes
